import { render, staticRenderFns } from "./column-operations.vue?vue&type=template&id=72ee2d19&scoped=true&"
import script from "./column-operations.vue?vue&type=script&lang=js&"
export * from "./column-operations.vue?vue&type=script&lang=js&"
import style0 from "./column-operations.vue?vue&type=style&index=0&id=72ee2d19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee2d19",
  null
  
)

export default component.exports